<template>
  <Teleport to="body">
    <div
      v-if="show"
      class="tw-fixed tw-inset-0 tw-z-[60] tw-overflow-y-auto"
      @keydown.esc="$emit('close')"
    >
      <div class="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-p-4">
        <div
          class="tw-fixed tw-inset-0 tw-bg-slate-900 tw-bg-opacity-75 tw-transition-opacity"
          @click="$emit('close')"
        />
        <div class="tw-relative tw-w-full tw-max-w-4xl">
          <button
            type="button"
            class="tw-absolute tw--top-3 tw--right-3 tw-z-10 tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-text-slate-700 tw-h-9 tw-w-9 tw-shadow-lg hover:tw-bg-slate-100"
            aria-label="Close delivery guide video"
            @click="$emit('close')"
          >
            <span class="tw-text-lg tw-leading-none">×</span>
          </button>

          <div class="tw-relative tw-w-full tw-overflow-hidden tw-rounded-2xl tw-bg-black tw-shadow-2xl tw-pb-[56.25%]">
            <iframe
              :src="embedUrl"
              title="Watch Delivery Guide"
              class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            />
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { computed, watch, onBeforeUnmount } from 'vue'

export default {
  name: 'DeliveryVideoModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    videoId: {
      type: String,
      default: 'ZRZXQreE224'
    }
  },
  emits: ['close'],
  setup(props) {
    const embedUrl = computed(() => {
      return `https://www.youtube-nocookie.com/embed/${props.videoId}?autoplay=1&rel=0&modestbranding=1`
    })

    watch(() => props.show, (isOpen) => {
      document.body.style.overflow = isOpen ? 'hidden' : ''
    })

    onBeforeUnmount(() => {
      document.body.style.overflow = ''
    })

    return { embedUrl }
  }
}
</script>
